import React from "react";
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loader } from 'components/Loader';

const Component =  ({ children }) => {
    return <>{children}</>
};

const LoginRedirect = withAuthenticationRequired(Component, {
    onRedirecting: () => <Loader fullheight={"true"} />
});

export { LoginRedirect }
